import request from '../utils/request';

export function getAuthLog(params) {
  return request({
    url: '/auditTrail/auth',
    method: 'get',
    data: params,
  });
}
